export default {
  label: 'Category',
  placeholder: 'None',
};
